import { Helmet } from "react-helmet-async";

const siteName = "Praroha Greens";
const baseUrl = "https://prarohagreens.com";
const defaultDesc = "Farm-grown nutrient-dense microgreens delivered fresh to your kitchen. Experience organic, chemical-free microgreens packed with 4-40x more nutrients.";
const defaultImage = `${baseUrl}/og-image.jpg`;

const orgSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "Praroha Greens",
  "url": baseUrl,
  "logo": `${baseUrl}/praroha-logo-header.png`,
  "description": defaultDesc,
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Landmark Residency, Madeenaguda, Miyapur",
    "addressLocality": "Hyderabad",
    "addressRegion": "Telangana",
    "postalCode": "500049",
    "addressCountry": "IN"
  },
  "contactPoint": {
    "@type": "ContactPoint",
    "telephone": "+91-9640300086",
    "contactType": "customer service"
  },
  "sameAs": [
    "https://www.instagram.com/prarohagreens/",
    "https://www.facebook.com/p/Praroha-Greens-61573828271977/",
    "https://in.linkedin.com/company/praroha-greens",
    "https://www.youtube.com/@prarohagreens"
  ]
};

const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "Praroha Greens",
  "image": `${baseUrl}/praroha-logo-header.png`,
  "url": baseUrl,
  "telephone": "+91-9640300086",
  "priceRange": "₹₹",
  "address": orgSchema.address,
  "openingHours": "Mo-Su 08:00-20:00",
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": "17.4875",
    "longitude": "78.3539"
  }
};

export function SEO({ title, description, keywords, path = "", image, jsonLd }) {
  const fullTitle = title ? `${title} | ${siteName}` : `${siteName} - Fresh Microgreens, Pure Nutrition`;
  const desc = description || defaultDesc;
  const canonicalUrl = `${baseUrl}${path}`;
  const ogImage = image || defaultImage;

  const schemas = [orgSchema];
  if (path === "/" || path === "") schemas.push(localBusinessSchema);
  if (jsonLd) schemas.push(jsonLd);

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      {keywords && <meta name="keywords" content={keywords} />}
      <meta name="author" content="Praroha Greens" />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:locale" content="en_IN" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={ogImage} />

      {/* JSON-LD Structured Data */}
      {schemas.map((schema, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  );
}
